import React, { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import SupplierDueFilters from "./components/SupplierDueFilters";
import SupplierDueTable from "./components/SupplierDueTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportSupplierDueCsv } from "./components/exportSupplierDueCsv";

const { Title } = Typography;

const SupplierDue = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const authInfo = useSelector((state) => state.authInfo);
  const navigate = useNavigate();
  // const { pathname } = useLocation();
  const { filters, list, totalBalance } = useSelector((state) => state.supplierDue); // ← add list + totalBalance
  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  
  
  const handleDownloadCsv = () => {
    exportSupplierDueCsv({
      list,
      totalBalance,
      title:    "Supplier Due Balance Report",
      filename: "supplier_due_balance",
    });
  };

  const hasData = list.length > 0;

  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Supplier Due Balance Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
                Supplier Due Balance Report
              </Title>
            </div>
          }
        extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <SupplierDueFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <SupplierDueTable authInfo={authInfo} />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Supplier Due Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <SupplierDueTable printMode={true} authInfo={authInfo} />
          )}
        />
      </div>
    </div>
  );
};

export default SupplierDue;
